import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const Privacy = () => (
  <div
    style={{
      padding: '1rem',
      lineHeight: 1.7,
      textAlign: 'left',
      maxWidth: '820px',
      margin: '0 auto'
    }}
  >
    {/* SEO */}
    <Helmet>
      <title>プライバシーポリシー | トレイルランニングシミュレータ</title>
      <meta
        name="description"
        content="TrailRunSim のプライバシーポリシー。Google AdSense・Analytics・Cookie・免責事項などを掲載。"
      />
      <meta
        name="keywords"
        content="トレラン, トレイルランニング, シミュレーター, プライバシー, Cookie, Google AdSense, Google Analytics"
      />

      {/* 🚫 インデックスさせない */}
      <meta name="robots" content="noindex, nofollow" />

      {/* 🔗 canonical をトップページへ向ける */}
      <link rel="canonical" href="https://trailrunsim.com/" />
    </Helmet>

    {/* 🍏 タイトル */}
    <h2>プライバシーポリシー</h2>

    <p style={{ margin: '0.6rem 0 1.2rem', color: '#444' }}>
      TrailRunSim のプライバシーポリシーです。Google AdSense や Google Analytics を通じたデータ収集、
      Cookie の利用、免責事項、プライバシーポリシーの更新について明記しています。
      利用者の皆さまに安心してご利用いただけるよう、適切な情報管理に努めています。
    </p>

    {/* 🍏 個人情報の収集 */}
    <div
      style={{
        marginTop: '1.6rem',
        padding: '1rem',
        background: 'rgba(255,255,255,0.55)',
        borderRadius: '12px'
      }}
    >
      <h3 style={{ marginTop: 0 }}>個人情報の収集について</h3>
      <p style={{ margin: '0.4rem 0 0.8rem', color: '#444' }}>
        当サイトでは、ユーザーの氏名、住所、メールアドレスなどの個人情報を収集することはありません。
        お問い合わせフォームを通じて任意で提供された情報については、目的以外には使用いたしません。
      </p>
    </div>

    {/* 🍏 Google AdSense */}
    <div
      style={{
        marginTop: '1.6rem',
        padding: '1rem',
        background: 'rgba(255,255,255,0.55)',
        borderRadius: '12px'
      }}
    >
      <h3 style={{ marginTop: 0 }}>Google AdSense について</h3>
      <p style={{ margin: '0.4rem 0 0.8rem', color: '#444' }}>
        当サイトでは第三者配信の広告サービス「Google AdSense」を利用しています。
        広告配信事業者は、ユーザーの興味に応じた広告を表示するために Cookie を使用することがあります。
      </p>
      <p style={{ margin: '0.4rem 0 0.8rem', color: '#444' }}>
        パーソナライズ広告は広告設定から無効化できます。
        <br />
        <a
          href="https://adssettings.google.com/authenticated"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#007aff', fontWeight: 600 }}
        >
          Google広告設定
        </a>
      </p>
    </div>

    {/* 🍏 Google Analytics */}
    <div
      style={{
        marginTop: '1.6rem',
        padding: '1rem',
        background: 'rgba(255,255,255,0.55)',
        borderRadius: '12px'
      }}
    >
      <h3 style={{ marginTop: 0 }}>アクセス解析ツールについて</h3>
      <p style={{ margin: '0.4rem 0 0.8rem', color: '#444' }}>
        当サイトでは、アクセス状況の把握のために Google Analytics を利用することがあります。
        Google Analytics は Cookie を使用して匿名のトラフィックデータを収集します。
        これらの情報は個人を特定するものではありません。
      </p>
    </div>

    {/* 🍏 Cookie */}
    <div
      style={{
        marginTop: '1.6rem',
        padding: '1rem',
        background: 'rgba(255,255,255,0.55)',
        borderRadius: '12px'
      }}
    >
      <h3 style={{ marginTop: 0 }}>Cookie の利用について</h3>
      <p style={{ margin: '0.4rem 0 0.8rem', color: '#444' }}>
        当サイトでは、利便性向上やアクセス解析、広告配信のために Cookie を使用しています。
        Cookie はユーザーのブラウザに保存され、次回以降の訪問時に利用されます。
      </p>
    </div>

    {/* 🍏 お問い合わせ */}
    <div
      style={{
        marginTop: '1.6rem',
        padding: '1rem',
        background: 'rgba(255,255,255,0.55)',
        borderRadius: '12px'
      }}
    >
      <h3 style={{ marginTop: 0 }}>お問い合わせ</h3>
      <p style={{ margin: '0.4rem 0 0.8rem', color: '#444' }}>
        プライバシーポリシーに関するご質問は、
        <Link to="/contact" style={{ color: '#007aff', fontWeight: 600 }}>
          お問い合わせページ
        </Link>
        よりご連絡ください。
      </p>
    </div>

    {/* 🍏 不適切な広告 */}
    <div
      style={{
        marginTop: '1.6rem',
        padding: '1rem',
        background: 'rgba(255,255,255,0.55)',
        borderRadius: '12px'
      }}
    >
      <h3 style={{ marginTop: 0 }}>不適切な広告について</h3>
      <p style={{ margin: '0.4rem 0 0.8rem', color: '#444' }}>
        Google AdSense 経由で不適切な広告（ウイルス警告など）が表示される場合があります。
        見かけた際は、
        <Link to="/contact" style={{ color: '#007aff', fontWeight: 600 }}>
          お問い合わせページ
        </Link>
        よりご報告ください。
      </p>
    </div>

    {/* 🍏 免責事項 */}
    <div
      style={{
        marginTop: '1.6rem',
        padding: '1rem',
        background: 'rgba(255,255,255,0.55)',
        borderRadius: '12px'
      }}
    >
      <h3 style={{ marginTop: 0 }}>免責事項</h3>
      <p style={{ margin: '0.4rem 0 0.8rem', color: '#444' }}>
        当サイトの情報は正確性を保証するものではありません。
        万が一損害が生じた場合でも責任を負いかねます。
      </p>
    </div>

    {/* 🍏 更新日 */}
    <p style={{ marginTop: '1.6rem', fontSize: '0.9rem', color: '#555' }}>
      制定日：2025年6月
    </p>
  </div>
);

export default Privacy;
